var swiper = new Swiper(".block-cases--swiper", {
    slidesPerView: 2.5,
    spaceBetween: 20,
    autoHeight: true,
    centeredSlides: true,
    initialSlide: 1,
    loop: true,
    navigation: {
        nextEl: ".swiper-btn-custom-next",
        prevEl: ".swiper-btn-custom-prev",
    },
    breakpoints: {
        240: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 2.5,
            spaceBetween: 20,
        },
    },
});